var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightStandard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-chevron-right ms-2",
    viewBox: "0 0 8 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "chevron-right"), /*#__PURE__*/React.createElement("path", {
    d: "M0.61911,0.61818c0.10101,-0.10126 0.23816,-0.15817 0.38119,-0.15817c0.14303,0 0.28018,0.05691 0.38119,0.15817l6.46078,6.46078c0.10126,0.10101 0.15817,0.23816 0.15817,0.38119c0,0.14303 -0.05691,0.28018 -0.15817,0.38119l-6.46078,6.46078c-0.21052,0.21053 -0.55185,0.21053 -0.76237,0c-0.21052,-0.21052 -0.21052,-0.55185 0,-0.76237l6.08067,-6.07959v0l-6.08067,-6.07959c-0.10126,-0.10101 -0.15817,-0.23816 -0.15817,-0.38119c0,-0.14303 0.05691,-0.28018 0.15817,-0.38119z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightStandard);
export default __webpack_public_path__ + "static/media/chevron-right-standard.ddb768db.svg";
export { ForwardRef as ReactComponent };